/* eslint-disable no-script-url,jsx-a11y/anchor-is-valid */
import React from "react";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import SVG from "react-inlinesvg";
import { shallowEqual, useSelector } from "react-redux";
import { toAbsoluteUrl } from "../../../../../../_metronic/_helpers";

export const ProgramTableActions = ({
  row,
  openEditProgramPage,
  openDeleteProgramDialog,
  openDuplicateProgramPage,
  openActivateProgramDialog,
  openPointsDialog,
  openEmailDialog,
  openAttendanceDialog,
  openFullDialog,
  openBulkUploadPage
}) => {
  const access = useSelector((state) => state.auth.access, shallowEqual);
  return (
    <>
      <div>
        {/* Read-only roles (instructors) still take attendance and points,
            as on the Regular Class list. */}
        {access["batches"] == 0 && (
          <>
          {" "}
          <OverlayTrigger
            overlay={<Tooltip id="products-edit-tooltip">Edit Program</Tooltip>}
          >
            <a
              className="btn btn-icon btn-light btn-hover-primary btn-sm"
              onClick={() => {
                // console.log(row);
                openEditProgramPage(row.school_program_id);
              }}
            >
              <span className="svg-icon svg-icon-md svg-icon-primary">
                <SVG
                  src={toAbsoluteUrl(
                    "/media/svg/icons/Communication/Write.svg"
                  )}
                />
              </span>
            </a>
          </OverlayTrigger>
          <> </>
          {row.active_value === "Active" ? (
            <span>
              {/* Asad remember to add stuff to reactivate */}
              <OverlayTrigger
                overlay={
                  <Tooltip id="products-delete-tooltip">
                    {row.student_count > 0
                      ? "Cannot deactivate program with enrolled students"
                      : "Deactivate Program"}
                  </Tooltip>
                }
              >
                <a
                  className={`btn btn-icon btn-light btn-sm mr-1 ${
                    row.student_count > 0
                      ? "btn-light-disabled"
                      : "btn-hover-danger"
                  }`}
                  onClick={() => {
                    if (row.student_count === 0) {
                      openDeleteProgramDialog(row.school_program_id);
                    }
                  }}
                  style={{
                    cursor: row.student_count > 0 ? "not-allowed" : "pointer",
                    opacity: row.student_count > 0 ? 0.5 : 1,
                  }}
                >
                  <span className="svg-icon svg-icon-md svg-icon-danger">
                    <i className="fa fa-power-off text-success"></i>
                  </span>
                </a>
              </OverlayTrigger>

              {Number(row.class_full_ind) !== 0 ? (
                <OverlayTrigger
                  overlay={
                    <Tooltip id="program-not-full-tooltip">Mark as Not Full</Tooltip>
                  }
                >
                  <a
                    className="btn btn-icon btn-danger btn-hover-success btn-sm mr-1"
                    onClick={() => openFullDialog(row.school_program_id, false)}
                  >
                    <span className="svg-icon svg-icon-md svg-icon-danger">
                      <i className="fa fa-box text-default"></i>
                    </span>
                  </a>
                </OverlayTrigger>
              ) : (
                <OverlayTrigger
                  overlay={<Tooltip id="program-full-tooltip">Mark as Full</Tooltip>}
                >
                  <a
                    className="btn btn-icon btn-light btn-hover-danger btn-sm mr-1"
                    onClick={() => openFullDialog(row.school_program_id, true)}
                  >
                    <span className="svg-icon svg-icon-md svg-icon-danger">
                      <i className="fa fa-box-open text-primary"></i>
                    </span>
                  </a>
                </OverlayTrigger>
              )}
              <OverlayTrigger
                overlay={
                  <Tooltip id="products-duplicate-tooltip">
                    Duplicate Program
                  </Tooltip>
                }
              >
                <a
                  className="btn btn-icon btn-light btn-hover-primary btn-sm"
                  onClick={() => openDuplicateProgramPage(row.school_program_id)}
                >
                  <span className="svg-icon svg-icon-md svg-icon-danger">
                    <i className="far fa-copy text-success"></i>
                  </span>
                </a>
              </OverlayTrigger>
            </span>
          ) : (
            <OverlayTrigger
              overlay={
                <Tooltip id="products-delete-tooltip">Activate Program</Tooltip>
              }
            >
              <a
                className="btn btn-icon btn-light btn-hover-danger btn-sm"
                onClick={() => openActivateProgramDialog(row.school_program_id)}
              >
                <i className="fa fa-power-off"></i>
              </a>
            </OverlayTrigger>
          )}{" "}
          </>
        )}
          <OverlayTrigger
            overlay={
              <Tooltip id="program-attendance-tooltip">Open Attendance</Tooltip>
            }
          >
            <a
              className="btn btn-icon btn-light btn-hover-primary btn-sm mr-1"
              onClick={() => openAttendanceDialog(row.school_program_id, row.day)}
            >
              <i className="fa fa-user-check"></i>
            </a>
          </OverlayTrigger>
          <OverlayTrigger
            overlay={
              <Tooltip id="products-delete-tooltip">Add/Remove Points</Tooltip>
            }
          >
            <a
              className="btn btn-icon btn-light btn-hover-primary btn-sm mr-1"
              onClick={() => openPointsDialog(row.school_program_id)}
            >
              <span className="svg-icon svg-icon-md svg-icon-success">
                <SVG
                  src={toAbsoluteUrl("/media/svg/icons/Shopping/Ticket.svg")}
                ></SVG>
              </span>
            </a>
          </OverlayTrigger>
          {access["batches"] == 0 && (
            <OverlayTrigger
              overlay={<Tooltip id="products-delete-tooltip">Email</Tooltip>}
            >
              <a
                className="btn btn-icon btn-light btn-hover-danger btn-sm mr-1"
                onClick={() => openEmailDialog(row.school_program_id)}
              >
                <span className="svg-icon svg-icon-md svg-icon-primary">
                  <SVG
                    src={toAbsoluteUrl(
                      "/media/svg/icons/Communication/Mail.svg"
                    )}
                  ></SVG>
                </span>
              </a>
            </OverlayTrigger>
          )}
          {/* NEW ICON BUTTON - Navigate to new page */}
          {access["batches"] == 0 && (
            <OverlayTrigger
              overlay={
                <Tooltip id="products-view-details-tooltip">
                  Batch Upload Students
                </Tooltip>
              }
            >
              <a
                className="btn btn-icon btn-light btn-hover-info btn-sm mr-1"
                onClick={() => openBulkUploadPage(row.school_program_id)}
              >
                <span className="svg-icon svg-icon-md svg-icon-info">
                  <SVG
                    src={toAbsoluteUrl("/media/svg/icons/Files/Upload.svg")}
                  ></SVG>
                </span>
              </a>
            </OverlayTrigger>
          )}
      </div>
    </>
  );
};